// extracted by mini-css-extract-plugin
export default {"tagsGroupPopover":"TagsGroup_tagsGroupPopover__UaRds"};